module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changePlan":"Change plan","subject":"You now have a subscription for the plan “{plan}”. You will be automatically switched to the plan “{nextPlan}” at the end of the current pay period {expirationText}. You can cancel the change at any time until the first payment on your new plan (1 day before the end of the current pay period).","confirm":"Confirm"}}')
  delete Component.options._Ctor
}
